<template>

  <section class="px-14 pt-3 md-max:pt-0 sm-max:px-5 font-21 md-max:text-base">

    <div class="text-base text-center lg:text-21" v-html="title"></div>

    <div class="grid grid-cols-3 m-auto mt-6 max-w-2xl sm-max:grid-cols-3 sm-max:gap-y-10">

      <nuxt-img
          class="m-auto col-span-1 sm-max:col-span-2 sm-max:w-24 sm-max:order-[-2]"
          width="90"
          height="49"
          loading="lazy"
          format="webp"
          :alt="logo1Alt"
          :src="logo1Src"
      ></nuxt-img>


      <nuxt-img
          class="m-auto col-span-1 sm-max:col-span-2 sm-max:order-[-2] sm-max:w-24"
          width="140"
          height="54"
          loading="lazy"
          format="webp"
          :alt="logo3Alt"
          :src="logo3Src"
      ></nuxt-img>

      <nuxt-img
          class="col-span-1 m-auto sm-max:col-span-2 sm-max:w-24"
          width="140"
          height="66"
          loading="lazy"
          format="webp"
          :alt="logo4Alt"
          :src="logo4Src"
      ></nuxt-img>

    </div>

  </section>

</template>


<script setup>

defineProps({
  title: {
    type: String,
    default: 'Free shipping on your first order!'
  },
  logo1Alt: {
    type: String,
    default: 'logo-norton'
  },
  logo1Src: {
    type: String,
    default: '/assets/images/logo-1.jpg'
  },
  logo2Alt: {
    type: String,
    default: 'logo-truste'
  },
  logo2Src: {
    type: String,
    default: '/assets/images/logo-2.jpg'
  },
  logo3Alt: {
    type: String,
    default: 'logo-pci'
  },
  logo3Src: {
    type: String,
    default: '/assets/images/logo-3.jpg'
  },
  logo4Alt: {
    type: String,
    default: 'logo-256bit'
  },
  logo4Src: {
    type: String,
    default: '/assets/images/logo-4.jpg'
  },
})


defineBuilderComponent({
    friendlyName: "FreeShippingImages",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "Free shipping on your first order!"
        },
        {
            name: "logo1Alt",
            type: "text",
            defaultValue: "logo-norton"
        },
        {
            name: "logo1Src",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/logo-1.jpg",
            required: true
        },
        {
            name: "logo2Alt",
            type: "text",
            defaultValue: "logo-truste"
        },
        {
            name: "logo2Src",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/logo-2.jpg",
            required: true
        },
        {
            name: "logo3Alt",
            type: "text",
            defaultValue: "logo-pci"
        },
        {
            name: "logo3Src",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/logo-3.jpg",
            required: true
        },
        {
            name: "logo4Alt",
            type: "text",
            defaultValue: "logo-256bit"
        },
        {
            name: "logo4Src",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/logo-4.jpg",
            required: true
        }
    ]
});
</script>